export enum LogType {
    AddBenefit = "AddBenefit",
    ConsumeBenefit = "ConsumeBenefit",
    Invalid = "Invalid",
    RevertPoints = "RevertPoints"
}